import { render, staticRenderFns } from "./CdnCreate.vue?vue&type=template&id=acfb6b86&scoped=true"
import script from "./CdnCreate.vue?vue&type=script&lang=js"
export * from "./CdnCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb6b86",
  null
  
)

export default component.exports